import React, { useCallback, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { NavItem } from './navItem';

const Header = ({ noWheel, setNoWheel }) => {
  const { pathname } = useLocation();
  const [isHovering, setIsHovering] = useState(false);
  const [subFixed, setSubFixed] = useState(false);
  const [isHoverNum, setIsHoverNum] = useState(null);
  const [subActive, setSubActive] = useState(false);
  const [mobileNum, setMobileNum] = useState(0);
  const [toggle, setToggle] = useState(false);

  const toggleMenu = useCallback(
    (id) => {
      if (mobileNum === id) {
        setMobileNum(0);
      } else {
        setMobileNum(id);
      }
    },
    [mobileNum],
  );

  useEffect(() => {
    setToggle(false);
    setMobileNum(0);
    setSubActive(false);
  }, [pathname]);

  useEffect(() => {
    if (pathname === '/') {
      setSubFixed(false);
    } else {
      setSubFixed(true);
    }
  }, [pathname]);

  return (
    <>
      <header
        className={noWheel || subFixed ? 'Header active' : 'Header'}
        onMouseOver={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
      >
        <div className="inner flex">
          {noWheel || subFixed ? (
            <h1>
              <Link to="/">
                <img src="/images/logo/logo_active.png" alt="" className="pc" />
                <img src="/images/logo/logo_active_m.png" alt="" className="w400" />
              </Link>
            </h1>
          ) : (
            <h1>
              <Link to="/">
                <img src="/images/logo/logo_white.png" alt="" className="pc" />
                <img src="/images/logo/logo_white_m.png" alt="" className="w400" />
              </Link>
            </h1>
          )}
          <nav className="gnb">
            <ul className="gnbList flex">
              {NavItem.map((it, idx) => (
                <li key={it.id}>
                  <Link
                    to={it.link}
                    className={subActive && isHoverNum === idx ? 'gnbItem active' : 'gnbList'}
                    onMouseOver={() => {
                      setSubActive(true);
                      setIsHoverNum(idx);
                    }}
                    onMouseLeave={() => {
                      setSubActive(false);
                      setIsHoverNum(idx);
                    }}
                  >
                    <span>{it.title}</span>
                  </Link>
                  {subActive && (
                    <ul className={isHoverNum === idx ? 'lnb active' : 'lnb'}>
                      {it.arr.map((its) => (
                        <li
                          key={its.id}
                          onMouseOver={() => {
                            setSubActive(true);
                          }}
                          onMouseLeave={() => setSubActive(false)}
                        >
                          <Link
                            to={its.link}
                            className="lnbList"
                            // onMouseOver={() => setSubActive(true)}
                            // onMouseLeave={() => setSubActive(false)}
                          >
                            <span>{its.title}</span>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          </nav>
          <div className="contact">
            <Link to="/contact-us/partner/contact-us">
              <p>제휴문의</p>
            </Link>
          </div>
          <div
            className={toggle ? 'mobileToggle active' : 'mobileToggle'}
            onClick={() => setToggle(!toggle)}
          >
            <img src="/images/icon/menu_dark.png" alt="" />
            <img src="/images/icon/menu_white.png" alt="" />
          </div>
        </div>

        {/*반응형 네비*/}

        <nav className={toggle ? 'mobileNav on' : 'mobileNav'}>
          <div className="flex_column">
            <figure>
              <img src="/images/logo/logo_m.png" alt="반응형 로고" />
            </figure>
            <ul className="moblieGnb flex">
              {NavItem.map((it) => (
                <li key={it.id} className={mobileNum === it.id ? 'gnbItm active' : 'gnbItm'}>
                  <Link to={it.m_link} onClick={() => toggleMenu(it.id)}>
                    <span>{it.title}</span>
                  </Link>
                  <ul className="mobileLnb">
                    {it.arr.map((its) => (
                      <li key={its.id}>
                        <Link to={its.link} className="lnbList">
                          {its.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>
              ))}
            </ul>
          </div>
        </nav>
        {toggle && <div className="darkBg"></div>}
      </header>
    </>
  );
};

export default Header;
